import React, { ReactNode } from 'react';

import classNames from 'classnames';

import classes from './HeaderBar.module.scss';

export type HeaderBarProps = {
  children: ReactNode;
  className?: string;
  /**
   * Fix padding added by angular container
   */
  inAngularContainer?: boolean;
};

const HeaderBar = ({
  children,
  className,
  inAngularContainer = false,
}: HeaderBarProps) => {
  return (
    <header
      className={classNames(classes.header, className, {
        [classes.inAngularContainer]: inAngularContainer,
      })}
    >
      {children}
    </header>
  );
};

export { HeaderBar };
